import useI18n from '@/shared/hooks/usei18n'
import { CaretDownIcon } from '@/common/components/icons'
import {
  Popover,
  PopoverPanel,
  Transition,
  PopoverButton as PopoverButtonHeadless
} from '@headlessui/react'
import { Link } from 'react-router-dom'
import { PopoverToggleButton } from '@/common'

const menuItemClasses =
  'block p-2 w-full cursor-pointer text-left font-medium text-sm rounded-xs hover:bg-green-500 transition-colors duration-200'

export default function UserMenu({
  fullName,
  organizationName,
  onLogout,
  role
}: {
  fullName: string
  organizationName: string
  onLogout: () => Promise<void>
  role: 'ADMIN' | 'MANAGER'
}) {
  const { t } = useI18n()
  const isAdmin = role === 'ADMIN'
  
  return (
    <Popover>
      <PopoverToggleButton>
        <div className="space-y-1 text-left text-gray-700">
          <div
            className="font-semibold break-words max-w-[170px] truncate text-sm"
            title={organizationName}
          >
            {organizationName}
          </div>
        </div>
        <CaretDownIcon className="flex-shrink-0 size-6 text-gray-700" />
      </PopoverToggleButton>
      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <PopoverPanel
          transition
          anchor="bottom"
          className="w-[var(--button-width)] z-40 transition shadow-dropdown border p-2 rounded-xs bg-white duration-200 ease-in-out [--anchor-gap:8px] data-[closed]:-translate-y-1 data-[closed]:opacity-0"
        >
          <div className="space-y-4">
            {isAdmin && (
              <section className="space-y-2">
                <h4 className="text-gray-600 text-sm">{organizationName}</h4>
                <PopoverButtonHeadless
                  className={menuItemClasses}
                  as={Link}
                  to="/settings/organization-details"
                >
                  {t('common:navbar.userMenu.organizationDetails')}
                </PopoverButtonHeadless>
                <PopoverButtonHeadless className={menuItemClasses} as={Link} to="/user-management">
                  {t('common:navbar.userMenu.userManagement')}
                </PopoverButtonHeadless>
              </section>
            )}
            <section className="space-y-2">
              <h4 className="text-gray-600 text-sm">{fullName}</h4>
              <PopoverButtonHeadless className={menuItemClasses} as={Link} to="/profile">
                {t('common:navbar.userMenu.profile')}
              </PopoverButtonHeadless>
              <PopoverButtonHeadless className={menuItemClasses} as="button" onClick={onLogout}>
                {t('common:navbar.userMenu.logout')}
              </PopoverButtonHeadless>
            </section>
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  )
}
